export enum LotConfirmModalActions {
  CANCEL_OPTION = "cancelOption",
  UNRELEASE = "unrelease",
  CANCEL_OFFLINE = "cancelOffline",
  RETURN_PREVIOUS_STATUS = "returnPreviousStatus",
  MARK_SETTLED = "markSettled",
  CANCEL_CONTRACT = "cancelContract",
}
